import React, { Component } from "react";
import GeoreferencingComponent from "../components/GeoreferencingComponent";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "../../Actions/Dashboard";

import { setData, startMap } from '../components/mapScript';

class GeoreferencingContainer extends Component {
  componentDidUpdate() {
    setData(this.props.datos, this.props.result)
  }
  componentDidMount() {
    startMap()
  }
  render() {
    return <GeoreferencingComponent />;
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(GeoreferencingContainer);
